import { useEffect, useState } from 'react';
export const useModal = (id, isOpen) => {
    const [container, setContainer] = useState(null);
    useEffect(() => {
        if (!isOpen) {
            setContainer(null);
            return;
        }
        else {
            const modelRoot = document.createElement('div');
            modelRoot.setAttribute('id', `modal-${id}`);
            document.body.appendChild(modelRoot);
            setContainer(modelRoot);
            return () => {
                document.body.removeChild(modelRoot);
            };
        }
    }, [isOpen]);
    return container;
};
//# sourceMappingURL=use-modal.js.map